import PropTypes from 'prop-types';
import styled from 'styled-components';

import { cover } from '../../utils/styles';

export const TestimonialContainer = styled.blockquote`
  z-index: 10;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 848px;
  margin: 0 auto;
  padding: 0;
  &::before,
  &::after {
    position: absolute;
  }
  &::before {
    top: var(--size-space-medium);
    left: var(--size-space-medium);
  }
  &::after {
    bottom: var(--size-space-large);
    right: var(--size-space-medium);
  }

  span.background {
    ${cover}
    content:"";
    position: absolute;
    background-color: var(--color-primary-dark);
    opacity: 0.4;
    border-radius: var(--border-radius-large);
  }
  .testimonialHeader,
  .testimonialContent,
  .testimonialFooter {
    position: relative;
    z-index: 1;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    text-align: ${props => (props.center ? 'center' : 'left')};
  }
  .testimonialHeader {
    margin-top: -4rem;
    .avatar {
      flex-grow: 0;
      flex-shrink: 0;
      max-width: 8rem;
      margin: 0 auto;
      border-radius: 25%;
      height: auto;
    }
  }

  .testimonialContent {
    padding: var(--size-space-medium);
    margin: 0;
  }

  .testimonialFooter {
    padding: var(--size-space-small) var(--size-space-medium);
    padding-top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    .author {
      flex-grow: 1;
      flex-shrink: 1;
      h6 {
        color: var(--color-primary-light);
      }
    }
    .source {
      flex-grow: 0;
      flex-shrink: 0;
      h6 {
        opacity: 0.8;
      }
      &:hover h6 {
        opacity: 1;
        color: var(--color-primary-light);
      }
    }
  }
`;

TestimonialContainer.propTypes = {
  align_text: PropTypes.oneOf(['left', 'center', 'right']),
};

TestimonialContainer.defaultProps = {
  align_text: 'center',
};
